import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    LeadUpdateCompetitor as LeadUpdateCompetitorMutation,
    LeadUpdateCompetitorVariables,
    LeadCompetitorUpdateInput,
} from 'nutshell-graphql-types';

import LEAD_UPDATE_COMPETITOR from '../mutations/lead-update-competitor.graphql';

export const useLeadUpdateCompetitor = (): {
    leadUpdateCompetitor: (arg1: LeadCompetitorUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [leadUpdateCompetitor, {loading, error}] = useMutation<
        LeadUpdateCompetitorMutation,
        LeadUpdateCompetitorVariables
    >(LEAD_UPDATE_COMPETITOR);

    return {
        leadUpdateCompetitor: (input: LeadCompetitorUpdateInput) =>
            leadUpdateCompetitor({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
